<div *ngIf="isBusy" class="spinner-overlay"><img src="../assets/noun-loader-3784345-FFFFFF.png" class="spinner" /></div>
<header class="header-bar">
  <div class="header-content">
    <h1 class="app-name">{{this.title}}</h1>
    
    <div class="user-dropdown" (click)="toggleDropdown()" *ngIf="isAuthenticated">
      <span class="welcome-text">Welcome, {{firstName}}</span>
      <svg class="dropdown-arrow" [class.rotated]="isDropdownOpen" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
        <path d="M3 4.5L6 7.5L9 4.5"/>
      </svg>
      
      <div class="dropdown-menu" [class.show]="isDropdownOpen">
        <a href="#" class="dropdown-item" (click)="logout($event)">Log Out</a>
      </div>
    </div>
  </div>
</header>
<button
  type="button"
  class="settings-btn"
  [class.active]="isActiveRoute('settings')"
  (click)="navigateTo('settings')"
  aria-label="Camera settings"
  title="Camera settings">
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.76 6.76 0 0 1 0 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.93 6.93 0 0 1 0-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281Z" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
</button>
<hr />
<router-outlet />
<footer class="footer" *ngIf="isAuthenticated">
  <div class="footer-buttons">
    <button 
      class="btn footer-btn" 
      [class.active]="isActiveRoute('sessions')"
      (click)="navigateTo('sessions')">
      Sessions
    </button>
    <button *ngIf="isAdmin" 
      class="btn footer-btn" 
      [class.active]="isActiveRoute('admin')"
      (click)="navigateTo('admin')">
      Settings
    </button>
    <!--
    <button 
      class="btn footer-btn" 
      [class.active]="isActiveRoute('swings')"
      (click)="navigateTo('swings')">
      Swings
    </button>
    <button 
      class="btn footer-btn" 
      [class.active]="isActiveRoute('setup')"
      (click)="navigateTo('setup')">
      Setup
    </button>
    -->
  </div>
</footer>
